import { UserFacingError } from "@/models/helper/UserFacingError";
import { IRoomLocation } from "@/models/room/RoomLocation";
import axios from "axios";

export default class RoomLocationService {
  static async getBorrowingLocations(): Promise<IRoomLocation[]> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "room-location/borrowing",
        { withCredentials: true }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Failed to fetch list of room locations.",
      });
    }
  }

  static async getAssetBorrowingLocations(): Promise<IRoomLocation[]> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "room-location/asset-borrowing",
        { withCredentials: true }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Failed to fetch list of asset borrowing locations.",
      });
    }
  }
}
